(() => {
  const mobileQuery = window.matchMedia('(max-width: 999px)');
  const blockOrigins = new WeakMap();
  const specificationOrigins = new WeakMap();
  const observedSections = new WeakSet();
  let updateFrame;

  function getOrder(element) {
    return Number.parseInt(element.dataset.productBlockOrder || '', 10);
  }

  function registerBlock(block) {
    if (blockOrigins.has(block)) return;

    const placeholder = document.createComment(`product-block-${block.dataset.blockId || ''}`);
    block.before(placeholder);
    blockOrigins.set(block, placeholder);
  }

  function insertByEditorOrder(block, blockList) {
    const blockOrder = getOrder(block);
    const nextBlock = Array.from(blockList.children).find((candidate) => {
      if (candidate === block) return false;

      const candidateOrder = getOrder(candidate);
      return Number.isFinite(candidateOrder) && candidateOrder > blockOrder;
    });

    if (block.parentElement === blockList) {
      const expectedNextElement = nextBlock || null;
      if (block.nextElementSibling === expectedNextElement) return;
    }

    blockList.insertBefore(block, nextBlock || null);
    block.classList.add('product-info__block-item');
  }

  function restoreBlock(block) {
    const placeholder = blockOrigins.get(block);
    if (!placeholder?.parentNode) return;

    block.classList.remove('product-info__block-item');

    if (placeholder.nextSibling === block) return;

    placeholder.parentNode.insertBefore(block, placeholder.nextSibling);
  }

  function registerSpecificationsBlock(block) {
    if (block.hasAttribute('data-mobile-product-block') || specificationOrigins.has(block)) return;

    const placeholder = document.createComment(`product-specifications-${block.dataset.blockId || ''}`);
    block.before(placeholder);
    specificationOrigins.set(block, placeholder);
  }

  function restoreSpecificationsBlock(block) {
    const placeholder = specificationOrigins.get(block);
    if (!placeholder?.parentNode) return;

    if (placeholder.nextSibling === block) return;

    placeholder.parentNode.insertBefore(block, placeholder.nextSibling);
  }

  function syncSpecificationsPosition(section, blockList) {
    const description = blockList.querySelector('.product-info__block-item[data-block-type="description"]');
    const specifications = section.querySelector(
      '.product-info__block-item[data-block-type="product-specifications"], [data-mobile-product-block][data-block-type="product-specifications"]'
    );

    if (!specifications) return;

    if (mobileQuery.matches && description) {
      registerSpecificationsBlock(specifications);

      if (description.nextElementSibling !== specifications) {
        description.insertAdjacentElement('afterend', specifications);
      }
    } else if (!specifications.hasAttribute('data-mobile-product-block')) {
      restoreSpecificationsBlock(specifications);
    }
  }

  function syncSection(section) {
    const blockList = section.querySelector('.product-info__block-list');
    if (!blockList) return;

    section.querySelectorAll('[data-mobile-product-block]').forEach((block) => {
      registerBlock(block);

      if (mobileQuery.matches) {
        insertByEditorOrder(block, blockList);
      } else {
        restoreBlock(block);
      }
    });

    syncSpecificationsPosition(section, blockList);
  }

  function observeSections() {
    document.querySelectorAll('.shopify-section--main-product').forEach((section) => {
      if (!observedSections.has(section)) {
        const observer = new MutationObserver(queueSync);
        observer.observe(section, { childList: true, subtree: true });
        observedSections.add(section);
      }

      syncSection(section);
    });
  }

  function queueSync() {
    cancelAnimationFrame(updateFrame);
    updateFrame = requestAnimationFrame(observeSections);
  }

  mobileQuery.addEventListener('change', queueSync);
  document.addEventListener('shopify:section:load', queueSync);
  observeSections();
})();
